<template>
  <transition name="fade">
    <div v-if="show" class="contact-root">
      <form v-if="stage === 'input'" class="form" action="">
        <div :style="textStyle" class="text"></div>
        <label>
          <span :style="nameLabelStyle">お名前(必須)</span>
          <span v-show="errors.name" class="error">記入してください</span>
          <input
            v-model="name"
            @keyup="validate('name')"
            :style="nameInputStyle"
            type="text"
            placeholder="例) 日本 好太郎"
          />
        </label>

        <label>
          <span :style="emailLabelStyle">メールアドレス(必須)</span>
          <span v-show="errors.email" class="error">記入してください</span>
          <input
            v-model="email"
            @keyup="validate('email')"
            :style="emailInputStyle"
            type="text"
            placeholder="例) guest@example.com"
          />
        </label>

        <label>
          <span :style="telLabelStyle">電話番号(必須)</span>
          <span v-show="errors.tel" class="error">記入してください</span>
          <input
            v-model="tel"
            @keyup="validate('tel')"
            :style="telInputStyle"
            type="text"
            placeholder="例) 00000000000"
          />
        </label>

        <label>
          <span :style="contentLabelStyle">お問い合わせ内容(必須)</span>
          <span v-show="errors.content" class="error">記入してください</span>
          <textarea
            v-model="content"
            @keyup="validate('content')"
            :style="contentInputStyle"
            placeholder="例) 00000000000"
          />
        </label>

        <div @click="handleSubmit" :style="btnStyle" class="btn submit"></div>
      </form>

      <div class="confirm-wrap">
        <div v-if="stage === 'confirm'" class="confirm-root">
          <dl>
            <dt>お名前</dt>
            <dd>{{ name }}</dd>
          </dl>

          <dl>
            <dt>メールアドレス</dt>
            <dd>{{ email }}</dd>
          </dl>

          <dl>
            <dt>電話番号</dt>
            <dd>{{ tel }}</dd>
          </dl>

          <dl>
            <dt>お問い合わせ内容</dt>
            <dd>{{ chopopedContent }}</dd>
          </dl>
        </div>

        <div v-if="stage === 'confirm'" class="controls">
          <div @click="handleBack" class="btn back"></div>
          <div @click="handleSend" class="btn send"></div>
        </div>

        <div v-if="stage === 'thanks'" class="confirm-root">
          <p class="thanks"></p>
        </div>

        <div v-if="stage === 'thanks'" class="controls">
          <div @click="handleToTop" class="btn totop"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { fadeStyle, transformStyle } from '../../lib/styleGenerator'

const STAGES = {
  INPUT: 'input',
  CONFIRM: 'confirm',
  THANKS: 'thanks'
}

export default {
  name: 'pageContact',
  data() {
    return {
      stage: STAGES.INPUT,
      name: '',
      email: '',
      tel: '',
      content: '',
      errors: {
        name: false,
        email: false,
        tel: false,
        content: false
      },
      API_KEY: '608ce87e-9317-42d2-b258-54aa88340d37'
    }
  },

  computed: {
    chopopedContent() {
      const maxLen = 350

      return this.content.length > maxLen
        ? this.content.slice(0, maxLen) + '...'
        : this.content
    },

    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'contact'
    },

    scrollRate() {
      return this.$store.getters.contactPageRate
    },

    nameLabelStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 200 })
      }
    },

    nameInputStyle() {
      return {
        ...transformStyle(this.scrollRate, { scale: 0.5 }),
        ...fadeStyle(this.scrollRate)
      }
    },

    emailLabelStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },

    emailInputStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 80 })
      }
    },

    telLabelStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 200 })
      }
    },

    telInputStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 200 })
      }
    },

    contentLabelStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 250, y: -50 })
      }
    },

    contentInputStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 200, y: -50 })
      }
    },

    textStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 100 })
      }
    },

    btnStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 50, y: 100, scale: 1 }),
        ...fadeStyle(this.scrollRate)
      }
    }
  },

  methods: {
    validateAll() {
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = !this.$data[key]
      })

      return Object.values(this.errors).every((e) => !e)
    },
    validate(key) {
      this.errors[key] = !this.$data[key]
    },
    sendMail() {
      const endpoint = '/mail.php'
      const headers = {
        'Content-Type': 'application/json'
      }
      const data = this.$data

      return axios.post(endpoint, data, { headers })
    },
    handleSubmit() {
      if (this.validateAll()) {
        this.stage = STAGES.CONFIRM
        this.$store.commit('setScrollable', false)
      }
    },
    handleBack() {
      this.stage = STAGES.INPUT
      this.$store.commit('setScrollable', true)
    },
    handleSend() {
      this.sendMail()
        .then(() => {
          this.stage = STAGES.THANKS
          this.$store.commit('setScrollable', true)
          this.errors = {
            name: false,
            email: false,
            tel: false,
            content: false
          }
        })
        .catch((e) => {
          console.log(e)
          window.alert('メール送信に失敗しました。')
        })
    },
    handleToTop() {
      this.stage = STAGES.INPUT
      this.$store.commit('setPage', 'concept')

      if (this.$store.getters.isSP) {
        this.$store.commit('setPosition', -1000)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.contact-root
  position: absolute
  width: 100%
  top: 0
  left: 0

span, input, textarea
  font-family: 'Noto Serif JP', serif

.text
  position: absolute
  width: 41px
  height: 296px
  top: 0
  left: -70px
  background-image: url('/images/contact/text.png')
  background-repeat: no-repeat

.form
  width: 480px
  margin: 140px auto
  font-size: 14px
  position: relative
  span
    display: inline-block
    margin-bottom: 4px
  .error
    color: red
    margin-left: 4px

  input, textarea
    width: 100%
    margin-bottom: 20px
    border: 1px solid #CCC

  textarea
    height: 140px

.btn
  width: 200px
  height: 40px
  background-repeat: no-repeat
  cursor: pointer

.submit
  background-image: url('/images/contact/submit.svg')
  margin: 0 auto

.back
  background-image: url('/images/contact/back.svg')

.send
  background-image: url('/images/contact/send.svg')

.totop
  background-image: url('/images/contact/totop.svg')

.confirm-root
  width: 600px
  margin: 0 auto
  background-color: white
  box-sizing: border-box
  padding: 40px
  margin-top: 100px

  dl
    margin: 0
    margin-bottom: 10px
    dt
      background-repeat: no-repeat
      background-image: url('/images/chobo.svg')
      background-size: 10px 10px
      background-position: left center
      padding-left: 15px
    dd
      margin-left: 0
      word-break: break-all
      padding-left: 15px

.controls
  display: flex
  justify-content: space-evenly
  margin-top: 40px

.thanks
  width: 430px
  height: 260px
  background-image: url('/images/contact/thanks.svg')
</style>
